module.exports = __webpack_public_path__ + "media/images/icons/country_flags/id-f624e2c8444a7794b35736c30dd82dda.svg";